import moment from 'moment';

export const getTodayDateRange = () => [
  moment()
    .startOf('D')
    .toDate(),
  moment()
    .endOf('D')
    .toDate(),
];
